import styled from "styled-components";
import CompletedIcon from "../../images/Svg/Completed.svg";
import NumberOneIcon from "../../images/Svg/NumberOneIcon.svg";
import NumberTwoIcon from "../../images/Svg/NumberTwoIcon.svg";
import NumberTwo from "../../images/Svg/2.svg";
import NumberThreeIcon from "../../images/Svg/NumberThreeIcon.svg";
import NumberThree from "../../images/Svg/3.svg";
import RadiusIcon from "../../images/Svg/Radius.svg";
import RadiusUpIcon from "../../images/Svg/RadiusUp.svg";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const LoginStep = () => {
  const { twitter, deso } = useSelector((state) => state.auth);

  const showDeso = !deso?.user;
  const isTwitter = twitter?.user;
  const showTwitter = deso?.user && !isTwitter;
  const showSyncContent = deso?.user && isTwitter;

  let location = useLocation();
  let pn = location?.pathname;
  return (
    <>
      <Link className="responsive_padding" to="/login_diamond">
        <div
          className={`flex my-4 flex-col sm:flex-col ml-3 items-center md:flex-row responsive`}
        >
          <div className={`${showDeso ? "md:ml-2.5" : ""}`}>
            <img className="md:hidden" alt="" />

            {pn === "/login_diamond" ? (
              <>
                <img
                  className="hidden sm:hidden md:inline"
                  src={RadiusIcon}
                  alt=""
                />
                <img className="md:hidden inline" src={RadiusUpIcon} alt="" />
              </>
            ) : (
              <></>
            )}
          </div>

          <div
            className={`${
              !isTwitter
                ? // add condtion
                  `${
                    pn === "/login_twitter"
                      ? "responsive_margin_1 md:ml-8"
                      : "md:ml-4"
                  } `
                : pn == "/login_twitter"
                ? "md:ml-6 md:mt-0 responsive_margin_1"
                : showTwitter
                ? "md:ml-[16px] "
                : pn == "/sync_your_content"
                ? "md:ml-8 md:mt-0 responsive-last-1 "
                : deso?.user
                ? "md:ml-4 md:mt-0"
                : isTwitter
                ? " md:ml-6 md:mt-0"
                : "md:ml-4 md:mt-0"
            }`}
          >
            <img
              width={"32px"}
              src={pn === "/login_diamond" ? NumberOneIcon : CompletedIcon}
              alt=""
              className="mx-auto md:mx-0"
            />
            <div className="text-center md:text-left mt-[12px] sm:mt-[12px] md:mt-0">
              <StyledText>Login With DeSo</StyledText>
            </div>
          </div>
        </div>
      </Link>
      <Link
        className={`${pn == "/login_twitter" && "responsive-top"}`}
        to={deso?.user ? "/login_twitter" : pn}
      >
        <div
          className={`flex my-4 flex-col sm:flex-col ml-3 items-center md:flex-row responsive`}
          style={{ width: "110px" }}
        >
          <div className={`${showTwitter ? "md:ml-2.5" : ""}`}>
            {pn === "/login_twitter" && (
              <>
                <img
                  className="hidden sm:hidden md:inline mx-auto"
                  src={RadiusIcon}
                  alt=""
                />
                <img
                  className="md:hidden inline mx-auto"
                  src={RadiusUpIcon}
                  alt=""
                />
              </>
            )}
          </div>
          <div
            className={` ${
              showDeso
                ? "md:ml-8 responsive-margin"
                : pn == "/login_diamond" && !isTwitter
                ? "md:ml-4 responsive_new"
                : pn == "/login_diamond"
                ? "md:ml-6 md:mt-0 responsive_new"
                : pn == "/sync_your_content"
                ? "md:ml-8 responsive-last"
                : showSyncContent
                ? "md:ml-4"
                : "md:ml-4"
            } `}
          >
            <img
              className="mx-auto md:mx-0"
              width={"32px"}
              src={
                pn == "/login_twitter"
                  ? NumberTwoIcon
                  : showSyncContent
                  ? CompletedIcon
                  : NumberTwo
              }
              alt=""
            />
            <div className="text-center md:text-left mt-[12px] sm:mt-[12px] md:mt-0">
              <StyledText>Link your Social Media</StyledText>
            </div>
          </div>
        </div>
      </Link>
      <Link
        className={`${pn == "/sync_your_content" && ""}`}
        to={showSyncContent ? "/sync_your_content" : pn}
      >
        <div
          className={`flex my-4 flex-col sm:flex-col ml-3 items-center md:flex-row responsive`}
        >
          <div className={`${pn == "/sync_your_content" ? "md:ml-2.5" : ""}`}>
            {pn == "/sync_your_content" && (
              <>
                <img
                  className="hidden sm:hidden md:inline mx-auto"
                  src={RadiusIcon}
                  alt=""
                />
                <img
                  className="md:hidden inline mx-auto h-[6.5px]"
                  src={RadiusUpIcon}
                  alt=""
                />
              </>
            )}
          </div>
          <div
            className={`${
              pn == "/sync_your_content"
                ? "md:ml-4 sm:mt-[0.5rem]"
                : showDeso
                ? "md:ml-8 responsive-margin pr-3"
                : pn == "/login_diamond" && !isTwitter
                ? "md:ml-6 md:mt-2 responsive_deso pr-3"
                : showTwitter
                ? " md:ml-8 md:mt-2 responsive_deso pr-3"
                : " md:ml-6 responsive-margin_2 pr-3"
            }`}
          >
            <img
              width={"32px"}
              src={pn == "/sync_your_content" ? NumberThreeIcon : NumberThree}
              alt=""
              className="mx-auto md:mx-0"
            />
            <div className="text-center md:text-left mt-[12px] sm:mt-[12px] md:mt-0">
              <StyledText>Sync your content</StyledText>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default LoginStep;

const StyledText = styled.p`
  color: #585858;
  font-size: 13px;
  margin-top: 8px;
`;
